function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_map_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M184.6 48.6l-85-27.4L0 46.7l.1 215.4 99.5-26.4 85 26.1 98.9-24V21.4l-98.9 27.2zm-70.7 7.2L170 73.9l.4 153.2-56.6-16.4.1-154.9zM28.5 69.6l56.9-14 .1 154.6-57 15.1V69.6zM255 215.1l-56.5 12.2v-153l56.5-16v156.8z"
})));